<template>
  <AppBtn
    size="x-small"
    aria-label="Price tooltip"
    icon borderless still
    @click="visible = true"
  > 
    <AppIcon icon="mdi:info" :color="color || 'primary'" />
    <AppTooltip v-model="visible">
      <slot />
    </AppTooltip>
  </AppBtn>
</template>

<script setup lang="ts">
const visible = ref(false);
defineProps<{
  color?: string;
}>();
</script>